import React, { useState, useRef } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Autocomplete, CircularProgress, FormControl, Select, MenuItem
} from '@mui/material';

const OndemandWashDialog = ({ open, onClose }) => {
  const [dateTime, setDateTime] = useState('');
  const [washerQuery, setWasherQuery] = useState('');
  const [washerList, setWasherList] = useState([]);
  const [washerLoading, setWasherLoading] = useState(false);
  const [selectedWasher, setSelectedWasher] = useState(null);
  const [carQuery, setCarQuery] = useState('');
  const [carList, setCarList] = useState([]);
  const [carLoading, setCarLoading] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [price, setPrice] = useState('');
  const [washType, setWashType] = useState('');
  const washerDebounceRef = useRef();
  const carDebounceRef = useRef();

  // Debounced washer search for autocomplete
  const handleWasherInputChange = (event, value) => {
    setWasherQuery(value);
    setWasherLoading(true);
    if (washerDebounceRef.current) clearTimeout(washerDebounceRef.current);
    washerDebounceRef.current = setTimeout(() => {
      if (!value) {
        setWasherList([]);
        setWasherLoading(false);
        return;
      }
      const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
      fetch(`${process.env.REACT_APP_SERVER_URI}/washers/options?search=${encodeURIComponent(value)}`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      })
        .then(res => res.json())
        .then(result => {
          setWasherList(result || []);
          setWasherLoading(false);
        })
        .catch(() => {
          setWasherList([]);
          setWasherLoading(false);
        });
    }, 400);
  };

  // Debounced car search for autocomplete
  const handleCarInputChange = (event, value) => {
    setCarQuery(value);
    setCarLoading(true);
    if (carDebounceRef.current) clearTimeout(carDebounceRef.current);
    carDebounceRef.current = setTimeout(() => {
      if (!value) {
        setCarList([]);
        setCarLoading(false);
        return;
      }
      const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
      fetch(`${process.env.REACT_APP_SERVER_URI}/cars/options?search=${encodeURIComponent(value)}`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      })
        .then(res => res.json())
        .then(result => {
          setCarList(result || []);
          setCarLoading(false);
        })
        .catch(() => {
          setCarList([]);
          setCarLoading(false);
        });
    }, 400);
  };

  const handleSubmit = () => {
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    // Split dateTime into date and time for backend if needed
    console.log(dateTime);
    const date = new Date(dateTime);

    fetch(`${process.env.REACT_APP_SERVER_URI}/washes/ondemand`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
      body: JSON.stringify({
        date,
        washerId: selectedWasher ? selectedWasher._id : undefined,
        carId: selectedCar ? selectedCar._id : undefined,
        price,
        washType,
      }),
    })
      .then(res => {
        const ress = res.json()
      console.log(ress);
        return ress;
      })
      .then((data) => {
        console.log(data)
        setDateTime('');
        setWasherQuery('');
        setWasherList([]);
        setSelectedWasher(null);
        setCarQuery('');
        setCarList([]);
        setSelectedCar(null);
        setPrice('');
        onClose();
      })
      .catch(() => {
        alert('Failed to add ondemand wash.');
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Add Ondemand Wash</DialogTitle>
      <DialogContent>
        <TextField
          label="Date & Time"
          type="datetime-local"
          value={dateTime}
          onChange={e => setDateTime(e.target.value)}
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
          required
        />
        <Autocomplete
          freeSolo
          options={washerList}
          getOptionLabel={option => option.name + (option.phone ? ` (${option.phone})` : '')}
          loading={washerLoading}
          value={selectedWasher}
          onChange={(event, value) => setSelectedWasher(value)}
          inputValue={washerQuery}
          onInputChange={handleWasherInputChange}
          required
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Washer"
              margin="normal"
              fullWidth
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {washerLoading ? <CircularProgress size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
        <Autocomplete
          freeSolo
          required
          options={carList}
          getOptionLabel={option =>
            (option.carName || option.name || '') +
            (option.regNo ? ` - ${option.regNo}` : '') +
            (option.ownerName ? ` (${option.ownerName})` : '')
          }
          loading={carLoading}
          value={selectedCar}
          onChange={(event, value) => setSelectedCar(value)}
          inputValue={carQuery}
          onInputChange={handleCarInputChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Car"
              margin="normal"
              required
              fullWidth
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {carLoading ? <CircularProgress size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
        <TextField
          label="Price"
          type="number"
          value={price}
          onChange={e => setPrice(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OndemandWashDialog;
